import { required, decimal } from 'vuelidate/lib/validators';

const addArticleValidations = {
  unitOfMeasureId: {
    required,
  },
  title: {
    required,
  },
  quantity: {
    required,
    decimal
  },
  vpc: {
    required,
    decimal
  },
  discount1: {
    decimal
  },
  amount: {
    decimal
  },
  taxAmount: {
    required,
    decimal
  },
  totalAmount: {
    required,
    decimal
  }
};

export default addArticleValidations;